import React, { useState, useRef, useEffect, useCallback } from "react";
import { useTranslation } from "react-i18next";
import useTour from "../../hooks/useTour";
import Button from "../buttons/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleQuestion, faCheck, faRotateRight } from "@fortawesome/pro-light-svg-icons";

const TourLauncher = () => {
  const { t } = useTranslation();
  const {
    isActive,
    sections,
    completedSections,
    startTour,
    startSection,
  } = useTour();
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);

  const handleClickOutside = useCallback((e) => {
    if (menuRef.current && !menuRef.current.contains(e.target)) {
      setIsOpen(false);
    }
  }, []);

  useEffect(() => {
    document.addEventListener("mouseup", handleClickOutside);
    return () => document.removeEventListener("mouseup", handleClickOutside);
  }, [handleClickOutside]);

  if (isActive) return null;

  const handleStartSection = (index) => {
    setIsOpen(false);
    startSection(index);
  };

  const handleRestartTour = () => {
    setIsOpen(false);
    startTour({ resetProgress: true, sectionsToSkip: [] });
  };

  return (
    <div className="tour-launcher" ref={menuRef} data-tour="tour-launcher">
      <Button
        variant="info"
        className="gap-1"
        onClick={() => setIsOpen(!isOpen)}
      >
        <FontAwesomeIcon icon={faCircleQuestion} size="lg" />
        <span>{t("dashboard.tour.launcher.title")}</span>
      </Button>

      {isOpen && (
        <div className="tour-launcher__menu">
          <div className="tour-launcher__menu-header">
            <span className="bold">{t("dashboard.tour.launcher.title")}</span>
          </div>
          <div className="tour-launcher__menu-list">
            {sections.map((section, i) => {
              const isDone = completedSections.includes(i);
              return (
                <button
                  key={section.id}
                  className={`tour-launcher__menu-item ${isDone ? "tour-launcher__menu-item--done" : ""}`}
                  onClick={() => handleStartSection(i)}
                >
                  <span className="tour-launcher__menu-index">{i + 1}</span>
                  <span className="tour-launcher__menu-label">
                    {t(section.tKey)}
                  </span>
                  {isDone && (
                    <FontAwesomeIcon
                      icon={faCheck}
                      className="tour-launcher__menu-check"
                    />
                  )}
                </button>
              );
            })}
          </div>
          <button
            className="tour-launcher__menu-restart"
            onClick={handleRestartTour}
          >
            <FontAwesomeIcon icon={faRotateRight} className="mr-2" />
            <span>{t("dashboard.tour.launcher.restart")}</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default TourLauncher;
